import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {EntityMegaHeaderModuleConfig} from "./entity-mega-header-module.config";
import {EntityMegaHeaderModuleStore} from "./entity-mega-header-module.store";
import {EntityMegaHeaderModuleHandlers} from "./handlers/entity-mega-header-module.handlers";

export class EntityMegaHeaderModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, EntityMegaHeaderModuleConfig, EntityMegaHeaderModuleStore, EntityMegaHeaderModuleHandlers];

}
